import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPackage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.067 15.325H4.425V2.184h13.642v13.141Zm-12.392-1.25h11.142V3.434H5.675v10.641Z"
    />
    <path
      fill="currentColor"
      d="M16.258 17.817H1.933V4.692h1.25v11.875h13.075v1.25ZM8.458 8.517a1.896 1.896 0 0 1-1.891-1.892c0-1.042.85-1.892 1.891-1.892 1.042 0 1.892.85 1.892 1.892 0 1.042-.85 1.892-1.892 1.892Zm0-2.534a.642.642 0 0 0-.641.642c0 .35.291.642.641.642.35 0 .642-.292.642-.642a.647.647 0 0 0-.642-.642ZM15.683 6h-4.566v1.25h4.566V6Z"
    />
    <path
      fill="currentColor"
      d="M8.458 13.167a1.896 1.896 0 0 1-1.891-1.892c0-1.041.85-1.891 1.891-1.891 1.042 0 1.892.85 1.892 1.891 0 1.042-.85 1.892-1.892 1.892Zm0-2.541a.642.642 0 0 0-.641.641c0 .35.291.642.641.642.35 0 .642-.292.642-.642a.647.647 0 0 0-.642-.641ZM15.683 10.643h-4.566v1.25h4.566v-1.25Z"
    />
  </svg>
);
export default SvgIcPackage;
